import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "base-breadcrumb-wrapper" }

import { useRouter } from 'vue-router';

interface BreadcrumbItem {
  step: number,
  label: string,
  to?: string,
  customLink?: string,
  params?: {
    [key: string | number]: any,
  },
  query?: {
    [key: string | number]: any,
  },
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseBreadcrumb',
  props: {
    items: null
  },
  emits: [
  'custom-link',
],
  setup(__props: any, { emit }) {



const router = useRouter();



function onClickCustomLink(item: BreadcrumbItem) {
  if (item.to) {
    router.push({
      name: item.to,
      params: item.params || {},
      query: item.query || {},
    });
  }

  emit('custom-link', item);
}

return (_ctx: any,_cache: any) => {
  const _component_va_breadcrumbs_item = _resolveComponent("va-breadcrumbs-item")!
  const _component_va_breadcrumbs = _resolveComponent("va-breadcrumbs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_va_breadcrumbs, {
      class: "base-breadcrumb",
      separator: ">"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
          return (_openBlock(), _createBlock(_component_va_breadcrumbs_item, {
            key: index,
            class: _normalizeClass([
          item.customLink ? 'clickable' : null
        ]),
            label: item.label,
            to: item.to ? { name: item.to } : '',
            onClick: ($event: any) => (onClickCustomLink(item))
          }, null, 8, ["class", "label", "to", "onClick"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})